<template>
  <ion-row class="ion-align-items-center ion-justify-content-center full-height">
    <div class="full-width ion-text-center">
      <template v-if="status === scannerStatus.RUNNING">
        <animated-svg :src="`/images/gateways/${type}/gateway_setup_searching.svg`"
                      class="width-90vw" />
        <div class="setup-text">
          <h1>{{ $t('settings.gateway.install.detect.Searching') }}</h1>
        </div>
      </template>
      <template v-else-if="status === scannerStatus.ERROR">
        <div class="setup-text">
          <img :src="$asset(`/images/gateways/${type}/gateway_setup_none.svg`)" class="width-90vw" v-svg-inject />
          <h1>{{ $t('settings.gateway.install.detect.Error') }}</h1>
          <gro-button class="ion-margin-top"
                      @click="search"
                      expand="full">
            {{ $t('settings.gateway.install.detect.Retry') }}
          </gro-button>
        </div>
      </template>
      <template v-else-if="candidates.length">
        <div class="setup-text ion-text-center">
          <img :src="$asset(`/images/gateways/${type}/gateway_setup_found.svg`)" class="width-90vw" v-svg-inject />
          <h1>{{ $t('settings.gateway.install.detect.Select gateway') }}</h1>
        </div>
      </template>
      <template v-else>
        <img :src="$asset(`/images/gateways/${type}/gateway_setup_none.svg`)" class="width-90vw" v-svg-inject />
        <div class="setup-text">
          <h1>{{ $t('settings.gateway.install.detect.No gateways') }}</h1>
          <ion-text color="medium">
            <p>{{ $t('settings.gateway.install.detect.Check before retry') }}</p>
          </ion-text>
          <gro-button class="ion-margin-top"
                      @click="search"
                      expand="full">
            {{ $t('settings.gateway.install.detect.Retry') }}
          </gro-button>
        </div>
      </template>
      <ion-list v-if="candidates.length" class="persistent-scrollbar" style="max-height: 40vh;">
        <div v-for="candidate in candidates" :key="candidate.hardwareAddress">
          <gro-button class="ion-margin-top"
                      expand="full"
                      :busy="isSelected"
                      @click="installCandidate(candidate)">
            {{ candidate.hardwareAddress || $t('common.Unknown') }}
          </gro-button>
        </div>
        <gro-button v-if="status !== scannerStatus.RUNNING"
                    color="light"
                    expand="full"
                    class="ion-margin-top"
                    @click="search">
          {{ $t('settings.gateway.install.detect.Retry') }}
        </gro-button>
      </ion-list>
    </div>
  </ion-row>

</template>

<script>
import { scannerStatus } from '~gro-modules/Arp'
import { gatewayMutations, gatewayQueries } from '~gro-modules/Gateway'
import gatewayTypes from '~gro-modules/Gateway/types'

export default {
  emits: ['failed', 'installStarted'],
  props: {
    type: {
      required: true,
      validator (value) {
        return gatewayTypes.includes(value)
      },
    },
  },
  data () {
    return {
      isSelected: false,
      candidates: [],
      status: scannerStatus.RUNNING,
      scannerStatus,
    }
  },
  methods: {
    async search () {
      this.status = scannerStatus.RUNNING
      await gatewayMutations.startScan(this.type)
      return this.checkStatus()
    },
    async installCandidate (candidate) {
      if (this.isSelected) {
        return
      }
      this.isSelected = true
      if (await gatewayMutations.installCandidate(candidate.hardwareAddress, this.type)) {
        this.$emit('installStarted', candidate)
      } else {
        this.$emit('failed')
      }
    },
    async checkStatus () {
      await this.$wait(5)
      const { status, candidates } = await gatewayQueries.getScanStatus()
      this.status = status
      this.candidates = candidates
      if (this.status === scannerStatus.RUNNING) {
        await this.$wait(5)
        return this.checkStatus()
      }
    },
  },
  mounted () {
    this.search()
  },
}
</script>
